export const defaultEntity = "scaffali";
export const entities = ["scaffali"];
export const labels = {
  scaffali: "Scaffali",
};
